import React, { useState } from "react";
import { AuthContext } from "../contexts/AuthContext";

function AuthProvider({ children }) {
  const localStorageUser = localStorage.getItem("user");
  const initalUser = localStorageUser ? JSON.parse(localStorageUser) : null;
  let [user, setUser] = useState(initalUser);
  let [firstName, setFirstName] = useState(
    initalUser && initalUser.firstName ? initalUser.firstName : ""
  );
  let [lastName, setLastName] = useState(
    initalUser && initalUser.lastName ? initalUser.lastName : ""
  );
  let [userName, setUserName] = useState(
    initalUser && initalUser.userName ? initalUser.userName : ""
  );
  let [role, setRole] = useState(
    initalUser && initalUser.role ? initalUser.role : ""
  );

  let signin = (newUser, callback) => {
    localStorage.setItem("user", JSON.stringify(newUser));
    setUser(newUser);
    setFirstName(newUser.firstName ? newUser.firstName : "");
    setLastName(newUser.lastName ? newUser.lastName : "");
    setUserName(newUser.userName ? newUser.userName : "");
    setRole(newUser.role ? newUser.role : "");
    callback();
  };

  let updateUser = (userObj, callback) => {
    const newUser = { ...user, ...userObj };
    localStorage.setItem("user", JSON.stringify(newUser));
    setUser(newUser);
    setFirstName(newUser && newUser.firstName ? newUser.firstName : firstName);
    setLastName(newUser && newUser.lastName ? newUser.lastName : lastName);
    setUserName(newUser && newUser.userName ? newUser.userName : userName);
    setRole(newUser && newUser.role ? newUser.role : role);
    callback();
  };

  let signout = (callback) => {
    localStorage.removeItem("user");
    setUser(null);
    callback();
  };

  let value = {
    user,
    firstName,
    lastName,
    userName,
    role,
    signin,
    signout,
    updateUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
